/**
 * @file Manages site header search events.
 */
((Drupal) => {
  class HeaderSearch {
    constructor() {
      this.initialize();
    }

    closeOnScape(event) {
      if (event.key === 'Escape') {
        document.querySelectorAll('.menu_link_content.show').forEach(item => {
          item.previousElementSibling.attributes['aria-expanded'].value = 'false';
          item.classList.remove('show');
        });

        // Move the focus to the trigger button
        document.querySelector('.menu-item__trigger').focus();
      }
    }

    toggleSearch(event) {
      const searchArea = document.querySelector('.site-wide-header__search-area');
      const mobileMenu = document.querySelector('.site-wide-header__main-menu-area');
      const mobileMenuBtn = document.querySelector('.site-wide-header__menu-toggle');
      document.querySelectorAll('.menu_link_content.show').forEach(item => {
          const menuLinkTrigger = item.parentElement.querySelector('.menu-item__trigger');
          menuLinkTrigger.attributes['aria-expanded'].value = 'false';
          item.classList.remove('show');
      });
      if (!searchArea.classList.contains('show')) {
        mobileMenu.classList.remove('show');
        document.body.classList.remove('menu-open');
        document.documentElement.classList.remove('menu-open');
        event.target.attributes['aria-expanded'].value = 'true';
        mobileMenuBtn.attributes['aria-expanded'].value = 'false';
        searchArea.classList.add('show');
      } else {
        event.target.attributes['aria-expanded'].value = 'false';
        searchArea.classList.remove('show');
      }
    }

    initialize() {
      const searchTrigger = document.querySelectorAll('.site-wide-header__search-toggle');
      if (searchTrigger.length) {
        this.initialized = true;
        searchTrigger.forEach(trigger => {
          if (trigger.classList.contains('initialized')) {
            return;
          }
          trigger.addEventListener('click', this.toggleSearch.bind(this));
          trigger.classList.add('initialized');
        });
      }
    }
  }

  Drupal.behaviors.headerSearch = {
    attach: function(context, settings) {
      if (document !== context) {
        return;
      }
      new HeaderSearch();
    }
  }
})(Drupal);